import { render, staticRenderFns } from "./PhoneMailBox.vue?vue&type=template&id=a9eae896&"
import script from "./PhoneMailBox.vue?vue&type=script&lang=js&"
export * from "./PhoneMailBox.vue?vue&type=script&lang=js&"
import style0 from "./PhoneMailBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports